import { useState, useEffect } from 'react';
import { Platform } from 'react-native';

const useIsMobileBrowser = (): boolean => {
  const [isMobileBrowser, setIsMobileBrowser] = useState(false);

  useEffect(() => {
    if (Platform.OS === 'web') {
      const detectMobileBrowser = () => {
        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera || '';
        const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        // Mobile device patterns in user agent
        const mobilePatterns = [
          /Android/i,
          /webOS/i,
          /iPhone/i,
          /iPad/i,
          /iPod/i,
          /BlackBerry/i,
          /Windows Phone/i,
          /Mobile/i,
        ];

        // Check if user agent contains mobile patterns
        const hasMobileUserAgent = mobilePatterns.some(pattern => pattern.test(userAgent));
        
        // Check if screen width is mobile-sized (768px is common breakpoint)
        const isMobileWidth = screenWidth <= 768;

        // Return true if either condition is met
        setIsMobileBrowser(hasMobileUserAgent || isMobileWidth);
      };

      // Initial detection
      detectMobileBrowser();

      // Listen for window resize events
      const handleResize = () => {
        detectMobileBrowser();
      };

      window.addEventListener('resize', handleResize);
      window.addEventListener('orientationchange', handleResize);

      // Cleanup
      return () => {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('orientationchange', handleResize);
      };
    } else {
      setIsMobileBrowser(false);
    }
  }, []);

  return isMobileBrowser;
};

export default useIsMobileBrowser;